import { z } from 'zod'

/**
 * Ce qu'on saisit pour se connecter : un e-mail, ou le pseudo d'un apprenant
 * sans e-mail (#271). Un pseudo ne contient jamais `@` ; l'API tranche de même.
 */
export function isEmailIdentifier(identifier: string): boolean {
  return identifier.includes('@')
}

/** Champ de connexion : un pseudo non vide, ou une adresse bien formée. */
export function loginIdentifierRule(messages: { required: string, email: string }) {
  return z.string().trim().min(1, { message: messages.required }).refine(
    value => !isEmailIdentifier(value) || z.string().email().safeParse(value).success,
    { message: messages.email },
  )
}
